import { useProseDensity } from './response-prose';
import { DENSITY_TYPE, type ProseDensity } from './response-scale';

/**
 * Body size for a density — a block's own content, equal to prose body.
 * See docs/response-rendering/README.md.
 */
export const responseBodyTextClass = (density: ProseDensity): string =>
  DENSITY_TYPE[density].body;

/**
 * One rung below body — a block's status or affordance, not its content.
 * See docs/response-rendering/README.md.
 */
export const responseMetaTextClass = (density: ProseDensity): string =>
  DENSITY_TYPE[density].meta;

/**
 * Both block rungs for the ambient column density.
 *
 * ```tsx
 * const { body, meta } = useResponseTypeClasses();
 * ```
 *
 * See docs/response-rendering/README.md.
 */
export const useResponseTypeClasses = (): { body: string; meta: string } => {
  const density = useProseDensity();
  return {
    body: responseBodyTextClass(density),
    meta: responseMetaTextClass(density),
  };
};
